(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-sur-header"]) return;
  try {
    
document.addEventListener('click', (event) => {
  document.querySelectorAll('.sur-catalog[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.sur-catalog[open]').forEach((menu) => {
    menu.removeAttribute('open');
    menu.querySelector('summary').focus();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-sur-shop"] && !Shopify.designMode) return;
  try {
    
class SurRevealGallery extends HTMLElement {
  connectedCallback() {
    if (this.observer || !('IntersectionObserver' in window)) return;
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (preference.matches) return;
    const cards = Array.from(this.querySelectorAll('.sur-photo'));
    const columns = window.innerWidth >= 900 ? 3 : window.innerWidth >= 600 ? 2 : 1;
    try {
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.dataset.reveal = 'visible';
          this.observer.unobserve(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -15px 0px' });
      cards.forEach((card, index) => {
        if (card.getBoundingClientRect().top < window.innerHeight - 20) return;
        card.style.setProperty('--sur-reveal-delay', (index % columns) * 180 + 'ms');
        card.dataset.reveal = 'pending';
        this.observer.observe(card);
      });
      this.showAll = () => {
        if (!preference.matches) return;
        cards.forEach(card => card.dataset.reveal = 'visible');
        this.observer.disconnect();
      };
      this.preference = preference;
      preference.addEventListener('change', this.showAll);
    } catch {
      cards.forEach(card => card.dataset.reveal = 'visible');
    }
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    if (this.showAll) this.preference?.removeEventListener('change', this.showAll);
  }
}
if (!customElements.get('sur-reveal-gallery')) customElements.define('sur-reveal-gallery', SurRevealGallery);

  } catch(e) { console.error(e); }
})();
})();
